import React from "react";
import {convertToQuarter, normalizePriceString} from "../helpers";
// @ts-ignore
import scss from "./sectionObject.module.scss";
import priceSvg from "../../svg/apartment/base_price.svg";
import floorSvg from "../../svg/apartment/floor.svg";
import totalAreaSvg from "../../svg/apartment/total_area.svg";
import deadlineSvg from "../../svg/apartment/deadline.svg";
import numberApartmentSvg from "../../svg/apartment/number.svg";
import decorationsSvg from "../../svg/apartment/decorations.svg";

import SectionObjectDownload from "./sectionObjectDownload/sectionObjectDownload";
import SectionObjectPreview from "./sectionObjectPreview/sectionObjectPreview";

const SectionObject = ({
  data,
  dataAgent,
  slideIndex,
  hasDownloadRoute,
}: any) => {
  const [planningState, setPlanningState] =
    React.useState<string>("Планировка");

  const objectPlanHandler = (e) => {
    const target = e.target as HTMLElement;

    if (target.id === "flat_plan") {
      setPlanningState("Планировка");
    } else {
      setPlanningState("Поэтажный план");
    }
  };

  const getDetails = (el) => {
    if (!el) return [];

    const details = [
      el.base_price_formatted && {
        icon: priceSvg,
        label: "Цена",
        value: typeof el.total_area === 'string' ? normalizePriceString(el.price_formatted) : el.price_formatted,
        bold: true,
      },
      el.total_area && {
        icon: totalAreaSvg,
        label: "Площадь",
        value: typeof el.total_area === 'string' ? `${normalizePriceString(el.total_area)} м²` : `${el.total_area} м²`,
      },
      typeof el.housing_complex.deadline === "string" && {
        icon: deadlineSvg,
        label: "Срок сдачи",
        value: convertToQuarter(el.housing_complex.deadline),
      },
      el.floor && {
        icon: floorSvg,
        label: "Этаж",
        value: el.floor,
      },
      el.number &&
        el.number !== "-" && {
          icon: numberApartmentSvg,
          label: "Номер объекта",
          value: el.number,
        },
      el.housing_complex.decorations?.length > 0 && {
        icon: decorationsSvg,
        label: "Отделка",
        isList: true,
        value: el.housing_complex.decorations.map(
          (decoration) => decoration.name
        ),
      },
    ];

    return details.filter(Boolean);
  };

  return (
    <section className="flex flex-col max-md:gap-[16px] gap-[30px] w-full">
      {hasDownloadRoute ? (
        <SectionObjectDownload
          data={data}
          planningState={planningState}
          dataAgent={dataAgent}
          objectPlanHandler={objectPlanHandler}
          getDetails={getDetails}
          slideIndex={slideIndex + 1}
        />
      ) : (
        <SectionObjectPreview
          data={data}
          planningState={planningState}
          dataAgent={dataAgent}
          objectPlanHandler={objectPlanHandler}
          getDetails={getDetails}
          slideIndex={slideIndex}
        />
      )}
    </section>
  );
};

export default SectionObject;
